module.exports = __webpack_public_path__ + "assets/6cb6bc31d9b7eb14e361a3be90410749.mp4";